import { render } from "./CenterWrapper.vue?vue&type=template&id=672b69fa&scoped=true"
const script = {}

import "./CenterWrapper.vue?vue&type=style&index=0&id=672b69fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672b69fa"]])

export default __exports__